<template>
  <field-layout id="associate-calendar-field" ref="field" :content="content">
    <h2>{{ i18n.t('activerecord.models.calendar.one') }}</h2>
    <div class="boolean">
      <toggle :initial-value="value" :label="label" @change="(payload) => updateFieldValue(payload.value)" />
    </div>
  </field-layout>
</template>

<script>
import FieldLayout from '@/campaign-form-shared/field-layout'
import FieldMixin from '@/campaign-form-shared/field-mixin'
import { mapState } from 'vuex'
import Toggle from '@/components/inputs/toggle'

export default {
  components: { Toggle, FieldLayout },

  mixins: [ FieldMixin ],

  computed: {
    ...mapState(['calendarOption']),

    label() {
      return this.i18n.t('events.form.single_association_option_hint',
                         {associated_entity_name: this.calendarOption[0]})
    }
  }
}
</script>


<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

::v-deep(select) {
  height: 58px;

  @include breakpoints.screen-mobile-only {
    height: 50px;
  }

}
</style>
